import React from 'react';
import { Avatar } from '../../components/Avatar.components';
import { Badge } from '../../components/Badge.components';
import { Text } from '../../components/Text.components';
import { Theme } from '../../utils/theme';

export const RenderAvatarList = ({ list, max }) => {
  const maxDisplay = max ? max : 3;
  let newList = [...list];

  const remainTags = list.length - maxDisplay;
  if (remainTags > 0) {
    newList = newList.slice(0, maxDisplay);
  }

  const renderTags = newList?.map((item, index) => {
    return (
      <Avatar
        key={index}
        src={item?._id?.profilePictureUrl}
        title={`${item?._id?.lastName} ${item?._id?.firstName}`}
        style={{ display: 'inline-block' }}
        size="38px"
        margin={index === 0 ? "0" : ' 0 0 0 -15px'}
      />
    );
  });

  return (
    <>
      {renderTags}{' '}
      {remainTags > 0 ? (
        <Badge
          key={'remaining'}
          solid
          spaceRight
          color={Theme.PrimaryGrey}
          style={{
            borderRadius: '100%',
            width: '30px',
            height: '30px',
            padding: '0 5px',
            display: 'inline-block',
            textAlign: 'center'
          }}
        >
          <Text color={Theme.PrimaryTextColor}>+{remainTags}</Text>
        </Badge>
      ) : null}
    </>
  );
};

export const RenderStatus = ({ status }) => {
  switch (status?.toLowerCase()) {
    case 'approved':
      return (
        <Badge borderRadius="2px" pad="2px" color={Theme.PrimaryGreen}>
          APPROVED
        </Badge>
      );
    case 'change-requested':
      return (
        <Badge borderRadius="2px" pad="2px" color={Theme.PrimaryYellow}>
          CHANGE REQUESTED
        </Badge>
      );
    case 'declined':
      return (
        <Badge borderRadius="2px" pad="2px" color={Theme.PrimaryRed}>
          DECLINED
        </Badge>
      );
    default:
      return null;
  }
};
